import { useContext } from 'react';
import {
	OtaPricesForPeriodContext,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/provider/OtaPricesForPeriodProvider';


export const useOtaPricesForPeriod = () => useContext(OtaPricesForPeriodContext)!;